import { __awaiter, __generator } from "tslib";
import * as idb from '@tencent/idb-es5';
import { IDBEngineDatabase } from './database';
import { IDBEngineTransaction } from './transaction';
import cmp from './cmp';
import { MissingIndexedDBError } from './error';
var IDBEngine = /** @class */ (function () {
    function IDBEngine() {
        if (typeof indexedDB === 'undefined') {
            throw new MissingIndexedDBError();
        }
        this.cmp = cmp;
    }
    IDBEngine.prototype.deleteDB = function (dbName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, idb.deleteDB(dbName)];
            });
        });
    };
    IDBEngine.prototype.setAspects = function (aspect) {
        this.engineAspects = aspect;
        this.engineAspects.openDB.patch(this, 'openDB');
        this.engineAspects.deleteDB.patch(this, 'deleteDB');
    };
    IDBEngine.prototype.openDB = function (dbName, schema, version, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var db;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, idb.openDB(dbName, version, {
                            upgrade: function (database, oldVersion, newVersion, transaction) {
                                var _a;
                                (_a = callback === null || callback === void 0 ? void 0 : callback.upgrade) === null || _a === void 0 ? void 0 : _a.call(callback, new IDBEngineDatabase(database, _this.engineAspects), oldVersion, newVersion, new IDBEngineTransaction(transaction));
                            },
                            blocked: function () { var _a; return (_a = callback === null || callback === void 0 ? void 0 : callback.blocked) === null || _a === void 0 ? void 0 : _a.call(callback); },
                            blocking: function () { var _a; return (_a = callback === null || callback === void 0 ? void 0 : callback.blocking) === null || _a === void 0 ? void 0 : _a.call(callback); },
                            terminated: function () { var _a; return (_a = callback === null || callback === void 0 ? void 0 : callback.terminated) === null || _a === void 0 ? void 0 : _a.call(callback); },
                        })];
                    case 1:
                        db = _a.sent();
                        return [2 /*return*/, new IDBEngineDatabase(db, this.engineAspects)];
                }
            });
        });
    };
    return IDBEngine;
}());
export { IDBEngine };
//# sourceMappingURL=engine.js.map